module.exports = __webpack_public_path__ + "img/bb11.95989464.png";